const _ = require('lodash')

const FORMATS = {
  CSV: Symbol('formats.csv'),
  TSV: Symbol('formats.tsv'),
  EXPLODED: Symbol('formats.exploded'),
}

const separators = {
  [FORMATS.CSV]: ',',
  [FORMATS.TSV]: '\t',
}

const formatCollection = (collection, format = FORMATS.CSV) => {
  const parts = []

  for (let [key, val] of Object.entries(collection)) {
    if (!Array.isArray(val)) {
      val = [val]
    }

    // Remove null and undefined, and rely on prescence of the key for that
    val = _.compact(val)

    const encodedKey = encodeURIComponent(key)
    let partAcc = ''
    let count = 0

    for (const valPart of val) {
      const encodedValPart = encodeURIComponent(valPart)

      if (format === FORMATS.EXPLODED) {
        partAcc += count++ === 0 ? '' : '&'
        partAcc += `${encodedKey}=${encodedValPart}`
      } else {
        if (!partAcc.length) {
          partAcc += encodedKey
        }

        partAcc += count++ === 0 ? '=' : separators[format]
        partAcc += encodedValPart
      }
    }

    parts.push(partAcc)
  }

  return parts.join('&')
}

formatCollection.FORMATS = FORMATS

module.exports = formatCollection
